<template>
  <div class="eating-no-data">
    <p>没有找到"{{text}}"的相关结果</p>
    <template v-if="isWeixin">
      <a
        href="https://shop101.doctopia.com.cn/app/index.php?i=3&c=entry&openid=W8SPYSG1sG3XPX0SJy50xj1OBW2x&do=tutor&m=yukiho_zvoice">问专家</a>
      <a href="javascript:void(0);" @click="handleAdd">增加新内容</a>
      <a href="http://consumer.doctopia.com.cn/Mobile/Threeredirect/socialGroup">问宝妈</a>
    </template>
  </div>
</template>

<script>
  import { getAddContent, getUnionid } from '../api/index'
  import { isWeixin } from '@/helpers'
  export default {
    name: 'NoData',
    props: {
      text: {
        type: String,
        default: ''
      }
    },
    computed: {
      isWeixin() {
        return isWeixin()
      }
    },
    methods: {
      async handleAdd () {
        const userInfo = await getUnionid()

        getAddContent({
          content: this.text,
          unionid: userInfo.data.data.unionid
        })
          .then((res) => {

            const code = res.data.code
            if (+code === 200) {
              this.$toast.text('谢谢你的反馈，我们尽快补充')
            } else {
              this.$toast.text(res.data.msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../styles/index";

  .eating-no-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: pxTOvw(120px);

    p {
      font-size: pxTOvw(35px);
      color: rgba(51, 51, 51, 1);
    }

    a {
      display: block;
      width: pxTOvw(400px);
      line-height: pxTOvw(77px);
      text-align: center;
      border-radius: pxTOvw(11px);
      color: #fff;
      background-color: rgb(57, 181, 74);
      font-size: pxTOvw(34px);
      margin-bottom: pxTOvw(44px);

      &:first-of-type {
        margin-top: pxTOvw(40px);
      }
    }
  }
</style>
